var render = function render(_c, _vm) {
  return _c(
    "div",
    { staticClass: "text-left margin-y-xl" },
    [
      _c("wa-message", {
        attrs: {
          content:
            "This icon will stop displaying immediately! No take-backsies. We'll delete it right away.",
          "icon-name": "faSkullCrossbones",
          theme: "danger",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "display-flex flex-row flex-nowrap flex-content-between flex-items-stretch",
          staticStyle: {
            "--button-margin-bottom": "0",
            gap: "var(--spacing-xl)",
          },
        },
        [
          _c(
            "button",
            {
              staticClass: "danger",
              attrs: { disabled: _vm.props.deleteInprocess },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.listeners["deleteIcon"].apply(null, arguments)
                },
              },
            },
            [
              _c("font-awesome-icon", {
                attrs: {
                  icon: _vm.parent.$v6.solid.faTrashCan,
                  "fixed-width": "",
                  size: "lg",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "margin-left-xs" }, [
                _vm._v("Yes, Delete This Icon"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "flat link",
              on: { click: _vm.listeners["hideConfirmDelete"] },
            },
            [_vm._v("\n      Cancel\n    ")]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }